<template>
  <div>
    <div id="contents">
      <div class="inner">
        <h3 class="main-title">포트폴리오</h3>
        <article class="common-txt-wrap">
          <ul>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('01')">
                <div class="thumbnail"><img src="../resource/images/1.png" alt=""/></div>
                <p class="title">B tv 우리동네광고</p>
              </button>
            </li>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('02')">
                <div class="thumbnail"><img src="../resource/images/img_portfolio02.png" alt=""/></div>
                <p class="title">KT스카이라이프 IPTV광고</p>
              </button>
            </li>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('03')">
                <div class="thumbnail"><img src="../resource/images/img_portfolio03.png" alt=""/></div>
                <p class="title">체험단 마케팅</p>
              </button>
            </li>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('04')">
                <div class="thumbnail"><img src="../resource/images/img_portfolio04.png" alt=""/></div>
                <p class="title">기자단 마케팅</p>
              </button>
            </li>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('05')">
                <div class="thumbnail"><img src="../resource/images/img_portfolio05.png" alt=""/></div>
                <p class="title">인스타 마케팅</p>
              </button>
            </li>
            <li>
              <button type="button" class="list-box open-layer" @click="this.handleClick('06')">
                <div class="thumbnail"><img src="../resource/images/img_portfolio06.png" alt=""/></div>
                <p class="title">바이럴 마케팅</p>
              </button>
            </li>
          </ul>
        </article>
      </div>
    </div>
  </div>
  <div class="layer-popup open" v-if="popupOpen">
    <div class="layer-content">
      <button type="button" class="btn-close close-layer" @click="handleClose">팝업 닫기</button>
      <div class="scroll-box flexbox">
        <img :src="require(`../resource/images/img_portfolio${no}.png`)" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>
// import image01 from "../resource/images/img_portfolio01.png"
export default {
  name: 'page-notice',
  components: {

  },
  data () {
    return {
      no:'',
      popupOpen: false,
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    handleClick(text) {
      console.log(text);
      this.no = text;
      this.popupOpen = true;
    },
    handleClose() {
      this.popupOpen = false;
    },
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  },


}
</script>